/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UbereatsStoreProvisionResponse } from '../../models/ubereats-store-provision-response';

export interface UbereatsStoreProvisionAggregatorStoreIdGet$Params {
  'Active-Tenant-Identifier': string;
  aggregatorStoreId: string;
}

export function ubereatsStoreProvisionAggregatorStoreIdGet(http: HttpClient, rootUrl: string, params: UbereatsStoreProvisionAggregatorStoreIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<UbereatsStoreProvisionResponse>> {
  const rb = new RequestBuilder(rootUrl, ubereatsStoreProvisionAggregatorStoreIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('aggregatorStoreId', params.aggregatorStoreId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UbereatsStoreProvisionResponse>;
    })
  );
}

ubereatsStoreProvisionAggregatorStoreIdGet.PATH = '/ubereats/storeProvision/{aggregatorStoreId}';
